import { Type } from '@angular/core';

import { ContainerComponent } from '../controls/container/container.component';
import { RowComponent } from '../controls/row/row.component';
import { CellComponent } from '../controls/cell/cell.component';
import { LabelComponent } from '../controls/label/label.component';
import { TextBoxComponent } from '../controls/text-box/text-box.component';
import { MultiLineTextBoxComponent } from '../controls/multi-line-text-box/multi-line-text-box.component';
import { RadioComponent } from '../controls/radio/radio.component';
import { MultiCheckBoxComponent } from '../controls/multi-check-box/multi-check-box.component';
import { DropDownComponent } from '../controls/drop-down/drop-down.component';
import { DigitalComponent } from '../controls/digital/digital.component';
import { DatetimeComponent } from '../controls/datetime/datetime.component';
import { ParagraphComponent } from '../controls/paragraph/paragraph.component';
import { SwitchComponent } from '../controls/switch/switch.component';
import { EmailComponent } from '../controls/email/email.component';
import { FileUploadOssComponent } from '../controls/file-upload-oss/file-upload-oss.component';
import { CarTypeComponent } from '../controls/car-type/car-type.component';
import { RegionComponent } from '../controls/region/region.component';

import {
  buildEntityPropertySpecification,
  buildPlaceholderPropertySpecification,
  buildReadonlyPropertySpecification,
  buildColumnLengthPropertySpecification,
  buildIdPropertySpecification,
  buildCaptionPropertySpecification,
  buildClassPropertySpecification,
  buildShowLabelPropertySpecification,
  buildDateTimePropertySpecification,
  buildDataSourcePropertySpecification,
  buildOptionValueControlPropertySpecification,
  buildDefaultValuePropertySpecification,
  buildDefaultValueMultiPropertySpecification,
  buildTextPropertySpecification,
  buildMultiTextPropertySpecification,
  buildMultiplePropertySpecification,
  buildSelectedConditionPropertySpecification,
  buildShowConditionPropertySpecification,
  buildNamePropertySpecification,
  buildIsHiddenPropertySpecification,
  buildIsBroadCastPropertySpecification,
  buildShowContentAtViewPropertySpecification,
  buildEnableEditAtViewPropertySpecification,
  buildCascadeParentNamePropertySpecification,
  buildUploadTemplateNamePropertySpecification,
  buildUploadTemplateUrlPropertySpecification,
  buildTemplateHiddenPropertySpecification,
  buildSelectFormPropertySpecification,
  buildDefaultTriggerCascadePropertySpecification,
  buildRegionSelectionTypePropertySpecification,
  buildAddButtonTextPropertySpecification,
  buildDeleteButtonTextPropertySpecification,
  buildClearDataWhenHiddenPropertySpecification
} from './property-specification-helper';

import {
  getRequiredValidatorSpecification,
  getUniqueValidatorSpecification,
  getStringLengthValidatorSpecification,
  getRegularExpressionValidatorSpecification,
  getDigitalRangeValidatorSpecification,
  getDigitalTypeValidatorSpecification,
  getFileTypeOfUploadValidatorSpecification,
  getFileSizeOfUploadValidatorSpecification,
  getUnionCheckValidatorSpecification
} from './validator-specification-helper';

import {
  ControlSpecification,
  ControlPropertySpecification,
  ControlValidatorSpecification
} from '../types/specification.types';
import { TextBoxViewModel, ValueControlViewModel } from '../types/control.types';
import { ControlTypeName } from '../types/control-type-name';
import { AssociatedDataEntity } from './specification-helper';
import { ChildFormControlComponent } from '../controls/child-form-control/child-form-control.component';

const controlGroupName: {
  container: string;
  editor: string;
  display: string;
  childForm: string;
} = {
  container: 'å®¹å¨æ§ä»¶',
  editor: 'ç¼è¾æ§ä»¶',
  display: 'æ¾ç¤ºæ§ä»¶',
  childForm: 'å­è¡¨åæ§ä»¶'
};

// export function getDefaultDesignHostComponent(): Type<any> {
//     return DesignHostComponent;
// }

export function getDefaultControlSpecifications(
  dataEntities: Array<AssociatedDataEntity>
): Array<ControlSpecification> {
  const specifications = new Array<ControlSpecification>();
  getValueControlSpecification(specifications, dataEntities);
  getContainerControlSpecifications(specifications);
  getDisplayControlSpecifications(specifications);
  getChildFormControlSpecifications(specifications);
  return specifications;
}

function getValueControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  getTextBoxControlSpecification(specifications, dataEntities);
  // MultiTextBox
  getMultiTextBoxControlSpecification(specifications, dataEntities);
  // RadioButton
  getRadioControlSpecification(specifications, dataEntities);
  // MultiCheck
  getMultiCheckControlSpecification(specifications, dataEntities);
  // DropDown
  getDropDownControlSpecification(specifications, dataEntities);
  // Digital
  getDigitalControlSpecification(specifications, dataEntities);
  // DateTime
  getDateTimeControlSpecification(specifications, dataEntities);
  // FileUpLoad
  getFileUploadControlSpecification(specifications, dataEntities);
  // Email
  getEmailControlSpecification(specifications, dataEntities);
  // Switch
  getSwitchControlSpecification(specifications, dataEntities);

  // CarType
  getCarTypeControlSpecification(specifications, dataEntities);

  // Region
  getRegionControlSpecification(specifications, dataEntities);
}

/**
 * TextBoxControlSpecification
 * @param specifications  ControlSpecification Array
 * @param dataEntities
 */
function getTextBoxControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    'TextBox',
    'TextBox',
    'fa fa-i-cursor',
    TextBoxComponent,
    [],
    new TextBoxViewModel('åè¡ææ¬'),
    dataEntities
  );

  spec.properties.push(buildDefaultValueMultiPropertySpecification(4));
  addShowSettingProperty(spec.properties);

  spec.validators.push(
    ...[
      getRequiredValidatorSpecification(),
      getUniqueValidatorSpecification(),
      getUnionCheckValidatorSpecification(),
      getStringLengthValidatorSpecification(),
      getRegularExpressionValidatorSpecification()
    ]
  );

  specifications.push(spec);
}

function getMultiTextBoxControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    ControlTypeName.multiTextBox,
    ControlTypeName.multiTextBox,
    'fa fa-text-height',
    MultiLineTextBoxComponent,
    [],
    new TextBoxViewModel('å¤è¡ææ¬'),
    dataEntities
  );

  spec.properties.push(buildDefaultValueMultiPropertySpecification(4));
  addShowSettingProperty(spec.properties);

  spec.validators.push(
    ...[
      getRequiredValidatorSpecification(),
      getUniqueValidatorSpecification(),
      getUnionCheckValidatorSpecification(),
      getStringLengthValidatorSpecification(),
      getRegularExpressionValidatorSpecification()
    ]
  );
  specifications.push(spec);
}

function getDigitalControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    ControlTypeName.digital,
    ControlTypeName.digital,
    'fa fa-sort-numeric-asc',
    DigitalComponent,
    [],
    new ValueControlViewModel('æ°å­'),
    dataEntities
  );

  spec.properties.push(buildDefaultValueMultiPropertySpecification(4));
  addShowSettingProperty(spec.properties);

  spec.validators.push(
    ...[
      getRequiredValidatorSpecification(),
      getUniqueValidatorSpecification(),
      getUnionCheckValidatorSpecification(),
      getDigitalRangeValidatorSpecification(),
      getDigitalTypeValidatorSpecification()
    ]
  );
  specifications.push(spec);
}

/**
 * RadioControlSpecification
 * @param specifications  ControlSpecification Array
 * @param dataEntities
 */
function getRadioControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const radio = buildOptionValueControlSpecification(
    ControlTypeName.radio,
    ControlTypeName.radio,
    'fa fa-dot-circle-o',
    RadioComponent,
    [],
    new ValueControlViewModel('åé'),
    dataEntities
  );
  specifications.push(radio);
}

/**
 * MultiCheckControlSpecification
 * @param specifications  ControlSpecification Array
 * @param dataEntities
 */
function getMultiCheckControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildOptionValueControlSpecification(
    ControlTypeName.multiCheckBox,
    ControlTypeName.multiCheckBox,
    'fa fa-check-circle',
    MultiCheckBoxComponent,
    [],
    new ValueControlViewModel('å¤é'),
    dataEntities
  );
  specifications.push(spec);
}

/**
 * DropDownControlSpecification
 * @param specifications  ControlSpecification Array
 * @param dataEntities
 */
function getDropDownControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildOptionValueControlSpecification(
    ControlTypeName.dropDown,
    ControlTypeName.dropDown,
    'fa fa-toggle-down',
    DropDownComponent,
    [],
    new ValueControlViewModel('ä¸ææ¡'),
    dataEntities
  );
  specifications.push(spec);
}

function getDateTimeControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    ControlTypeName.dateTime,
    ControlTypeName.dateTime,
    'fa fa-calendar',
    DatetimeComponent,
    [],
    new ValueControlViewModel('æ¥æ'),
    dataEntities
  );
  spec.properties.push(...buildDateTimePropertySpecification(4));
  spec.properties.push(buildDefaultValueMultiPropertySpecification(4));
  addShowSettingProperty(spec.properties);
  spec.validators.push(...[getRequiredValidatorSpecification(), getUnionCheckValidatorSpecification()]);
  specifications.push(spec);
}

function getFileUploadControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildFileUploadValueControlSpecification(
    ControlTypeName.fileUpLoad,
    ControlTypeName.fileUpLoad,
    'fa fa-upload',
    FileUploadOssComponent,
    [],
    new ValueControlViewModel('æä»¶ä¸ä¼ '),
    dataEntities
  );
  spec.validators.push(
    ...[
      getRequiredValidatorSpecification(),
      getUnionCheckValidatorSpecification(),
      getFileTypeOfUploadValidatorSpecification(),
      getFileSizeOfUploadValidatorSpecification()
    ]
  );
  specifications.push(spec);
}

function getEmailControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    ControlTypeName.email,
    ControlTypeName.email,
    'fa fa-envelope-open-o',
    EmailComponent,
    [],
    new ValueControlViewModel('Email'),
    dataEntities
  );
  spec.properties.push(buildDefaultValueMultiPropertySpecification(4));
  addShowSettingProperty(spec.properties);
  spec.validators.push(
    ...[getRequiredValidatorSpecification(), getUnionCheckValidatorSpecification(), getUniqueValidatorSpecification()]
  );
  specifications.push(spec);
}

function getCarTypeControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildControlSpecification(
    ControlTypeName.carType,
    ControlTypeName.carType,
    controlGroupName.editor,
    `fa fa-car`,
    CarTypeComponent,
    [],
    { caption: `è½¦åä¿¡æ¯`, showLabel: true }
  );

  const multiPropertyByCar = {
    brand: 'åç',
    brandId: 'åçID',
    carSeries: 'è½¦ç³»',
    carSeriesId: 'è½¦ç³»ID',
    carType: 'è½¦å',
    carTypeId: 'è½¦åID'
  };
  spec.properties.push(...getMultiPropertyControlPropertiesSpecification());
  spec.properties.push(...buildEntityPropertySpecification(dataEntities, multiPropertyByCar));
  spec.properties.push(buildSelectedConditionPropertySpecification(true));
  spec.properties.push(buildShowConditionPropertySpecification());
  spec.validators.push(getRequiredValidatorSpecification());
  spec.validators.push(getUnionCheckValidatorSpecification());
  specifications.push(spec);
}

function getRegionControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildControlSpecification(
    ControlTypeName.regionSelection,
    ControlTypeName.regionSelection,
    controlGroupName.editor,
    `fa fa-map-marker`,
    RegionComponent,
    [],
    { caption: `çå¸åºä¿¡æ¯`, showLabel: true }
  );

  const multiPropertyByRegion = {
    province: 'ç',
    provinceCode: 'çCode',
    city: 'å¸',
    cityCode: 'å¸Code',
    district: 'åº',
    districtCode: 'åºCode'
  };
  spec.properties.push(...getMultiPropertyControlPropertiesSpecification());
  spec.properties.push(...buildRegionSelectionTypePropertySpecification(3));
  spec.properties.push(...buildEntityPropertySpecification(dataEntities, multiPropertyByRegion));

  spec.properties.push(buildSelectedConditionPropertySpecification(true));
  spec.properties.push(buildShowConditionPropertySpecification());
  addPropertiesOrder(spec.properties);

  spec.validators.push(getRequiredValidatorSpecification());
  spec.validators.push(getUnionCheckValidatorSpecification());
  specifications.push(spec);
}

function getSwitchControlSpecification(
  specifications: Array<ControlSpecification>,
  dataEntities: Array<AssociatedDataEntity>
) {
  const spec = buildValueControlSpecification(
    ControlTypeName.switch,
    ControlTypeName.switch,
    'fa fa-toggle-on',
    SwitchComponent,
    [],
    new ValueControlViewModel('å¼å³'),
    dataEntities
  );
  addShowSettingProperty(spec.properties);
  specifications.push(spec);
}

function getContainerControlSpecifications(specifications: Array<ControlSpecification>) {
  // Container
  specifications.push(
    buildContainerSpecification(ControlTypeName.container, 'Container', 'fa fa-th-large', ContainerComponent, [], {
      class: 'container-fluid'
    })
  );
  // Row
  specifications.push(
    buildContainerSpecification(ControlTypeName.row, 'Row', 'fa fa-navicon', RowComponent, [], { class: 'row' })
  );
  // Cell
  const cell = buildContainerSpecification(ControlTypeName.cell, 'Cell', 'fa fa-clone', CellComponent, []);
  cell.properties.push(buildColumnLengthPropertySpecification(0));
  specifications.push(cell);
}

function getDisplayControlSpecifications(specifications: Array<ControlSpecification>) {
  // Label
  specifications.push(
    buildDisplayControlSpecification(
      'Label',
      'Label',
      'fa fa-font',
      LabelComponent,
      [buildTextPropertySpecification(2000)],
      { text: 'Label' }
    )
  );
  // pra
  specifications.push(
    buildDisplayControlSpecification(
      ControlTypeName.paragraph,
      ControlTypeName.paragraph,
      'fa fa-align-left',
      ParagraphComponent,
      [buildMultiTextPropertySpecification()],
      { text: 'æ®µè½' }
    )
  );
}

function buildDisplayControlPropertiesSpecification(customProperties: Array<ControlPropertySpecification>) {
  return [
    buildNamePropertySpecification(),
    ...customProperties,
    buildIsHiddenPropertySpecification(),
    buildClassPropertySpecification(),
    buildColumnLengthPropertySpecification()
  ];
}

/**
 * æå»ºæ¾ç¤ºæ§ä»¶è§æ ¼
 */
function buildDisplayControlSpecification(
  name: string,
  caption: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any
): ControlSpecification {
  const controlSpecification = buildControlSpecification(
    name,
    caption,
    controlGroupName.display,
    icon,
    component,
    properties,
    model
  );

  controlSpecification.properties = buildDisplayControlPropertiesSpecification(properties);
  return controlSpecification;
}

function buildControlSpecification(
  name: string,
  caption: string,
  groupName: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any
): ControlSpecification {
  const controlSpecification: ControlSpecification = {
    name: name,
    caption: caption,
    groupName: groupName,
    icon: icon,
    component: component,
    properties: new Array<ControlPropertySpecification>(),
    defaultModel: model,
    validators: new Array<ControlValidatorSpecification>()
  };

  if (properties) {
    controlSpecification.properties.push(...properties);
  }

  return controlSpecification;
}

/**
 * æå»ºå®¹å¨æ§ä»¶è§æ ¼
 */
function buildContainerSpecification(
  name: string,
  caption: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any
): ControlSpecification {
  const controlSpecification = buildControlSpecification(
    name,
    caption,
    controlGroupName.container,
    icon,
    component,
    properties,
    model
  );

  controlSpecification.properties.push(
    ...[buildNamePropertySpecification(), buildIsHiddenPropertySpecification(), buildClassPropertySpecification()]
  );

  return controlSpecification;
}

/**
 * @description æå»ºå¼æ§ä»¶
 *
 */
function buildValueControlSpecification(
  name: string,
  caption: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any,
  dataEntities?: Array<AssociatedDataEntity>
): ControlSpecification {
  const controlSpecification = buildControlSpecification(
    name,
    caption,
    controlGroupName.editor,
    icon,
    component,
    properties,
    model
  );
  controlSpecification.properties.push(
    ...[
      buildNamePropertySpecification(),
      buildIdPropertySpecification(),
      buildCaptionPropertySpecification(),
      buildPlaceholderPropertySpecification(),
      buildDefaultTriggerCascadePropertySpecification(),
      buildReadonlyPropertySpecification(),
      buildShowLabelPropertySpecification(),
      buildIsHiddenPropertySpecification(),
      buildClearDataWhenHiddenPropertySpecification(),
      buildIsBroadCastPropertySpecification(),
      buildShowContentAtViewPropertySpecification(),
      buildEnableEditAtViewPropertySpecification(),
      buildCascadeParentNamePropertySpecification(),
      buildColumnLengthPropertySpecification(),
      buildClassPropertySpecification()
    ]
  );
  controlSpecification.properties.push(...buildEntityPropertySpecification(dataEntities));
  // for (let i = 0; i < controlSpecification.properties.length; i++) {
  //   if (!controlSpecification.properties[i].order) {
  //     controlSpecification.properties[i].order = i;
  //   }
  // }
  addPropertiesOrder(controlSpecification.properties);

  return controlSpecification;
}

function buildFileUploadValueControlSpecification(
  name: string,
  caption: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any,
  dataEntities?: Array<AssociatedDataEntity>
): ControlSpecification {
  const controlSpecification = buildControlSpecification(
    name,
    caption,
    controlGroupName.editor,
    icon,
    component,
    properties,
    model
  );
  controlSpecification.properties.push(
    ...[
      buildNamePropertySpecification(),
      buildIdPropertySpecification(),
      buildCaptionPropertySpecification(),
      buildUploadTemplateNamePropertySpecification(),
      buildUploadTemplateUrlPropertySpecification(),
      buildDefaultTriggerCascadePropertySpecification(),
      buildTemplateHiddenPropertySpecification(),
      buildShowLabelPropertySpecification(),
      buildMultiplePropertySpecification('åè®¸å¤ä¸ªæä»¶ä¸ä¼ '),
      buildIsHiddenPropertySpecification(),
      buildClearDataWhenHiddenPropertySpecification(),
      buildIsBroadCastPropertySpecification(),
      buildEnableEditAtViewPropertySpecification(),
      buildCascadeParentNamePropertySpecification(),
      buildColumnLengthPropertySpecification(),
      buildClassPropertySpecification()
    ]
  );
  controlSpecification.properties.push(...buildEntityPropertySpecification(dataEntities));

  return controlSpecification;
}

function buildOptionValueControlSpecification(
  name: string,
  caption: string,
  icon: string,
  component: Type<any>,
  properties?: Array<ControlPropertySpecification>,
  model?: any,
  dataEntities?: Array<AssociatedDataEntity>
): ControlSpecification {
  const spec = buildControlSpecification(name, caption, controlGroupName.editor, icon, component, properties, model);

  spec.properties.push(...buildOptionValueControlPropertySpecification(dataEntities));
  spec.properties.push(...[buildDataSourcePropertySpecification()]);
  addShowSettingProperty(spec.properties);
  spec.validators.push(...[getRequiredValidatorSpecification(), getUnionCheckValidatorSpecification()]);

  return spec;
}
// æ·»å æ¾ç¤ºè®¾ç½®å±æ§
function addShowSettingProperty(specifications: ControlPropertySpecification[]) {
  specifications.push(...[buildSelectedConditionPropertySpecification(), buildShowConditionPropertySpecification()]);
}

/**
 * è·åå¤å±æ§æ§ä»¶å±æ§è§æ ¼
 */
function getMultiPropertyControlPropertiesSpecification() {
  return [
    buildNamePropertySpecification(),
    buildIdPropertySpecification(),
    buildCaptionPropertySpecification(),
    buildDefaultTriggerCascadePropertySpecification(),
    buildReadonlyPropertySpecification(),
    buildShowLabelPropertySpecification(),
    buildIsHiddenPropertySpecification(),
    buildClearDataWhenHiddenPropertySpecification(),
    buildIsBroadCastPropertySpecification(),
    buildShowContentAtViewPropertySpecification(),
    buildEnableEditAtViewPropertySpecification(),
    buildDefaultValueMultiPropertySpecification(),
    buildCascadeParentNamePropertySpecification(),
    buildColumnLengthPropertySpecification(),
    buildClassPropertySpecification()
  ];
}

function getChildFormControlSpecifications(specifications: ControlSpecification[]) {
  const spec = buildControlSpecification(
    ControlTypeName.childForm,
    'å­è¡¨å',
    controlGroupName.childForm,
    'la la-table',
    ChildFormControlComponent,
    [],
    new ValueControlViewModel('å­è¡¨å')
  );
  spec.properties.push(
    ...[
      buildNamePropertySpecification(),
      buildCaptionPropertySpecification(),
      ...buildSelectFormPropertySpecification(),
      buildAddButtonTextPropertySpecification(),
      buildDeleteButtonTextPropertySpecification(),
      buildDefaultTriggerCascadePropertySpecification(),
      buildShowLabelPropertySpecification(),
      buildIsHiddenPropertySpecification(),
      buildClearDataWhenHiddenPropertySpecification(),
      buildIsBroadCastPropertySpecification(),
      buildColumnLengthPropertySpecification(),
      buildClassPropertySpecification()
    ]
  );
  specifications.push(spec);
}

// å¢å å±æ§æåºorder
function addPropertiesOrder(properties: ControlPropertySpecification[]) {
  if (!properties) {
    return;
  }
  for (let i = 0; i < properties.length; i++) {
    if (!properties[i].order) {
      properties[i].order = i + 1;
    }
  }
}
